import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type NeverAssignedClaimType = string | string[];
export type NeverAssignedClaimArgs = {};

export const ruleNeverAssigned: SecurityRuleFactory<NeverAssignedClaimType, NeverAssignedClaimArgs> =
  createSimpleClaimRule<NeverAssignedClaimType, NeverAssignedClaimArgs>("never");

